import { styledComponent, Typography } from '@hermes/web-components'

export const TopKeywordText = styledComponent(Typography)(({ theme }) => ({
  ...theme.typography.body1,
  fontWeight: 500,
  color: theme.palette.text.darkNavy,
  fontSize: '15px',
  lineHeight: '28px'
}))
